import { SnackbarComponent } from "@/components";

const checkPopup = (url) => {
  const newWindow = window.open(url, "_blank");
  if (newWindow === null) {
    SnackbarComponent({
      errorMessage: "Pop Blocked! Please Enable Popups and Try Again",
      error: true,
    });
  }
};

export default checkPopup;
